import i18n from 'i18n';
import getFullUserName from 'utils/getFullUserName';
function getSharedByDetails(content) {
  if (!content.sharers) {
    return null;
  }
  var _content$sharers$ = content.sharers[0],
    sender_first_name = _content$sharers$.sender_first_name,
    sender_last_name = _content$sharers$.sender_last_name,
    sender_email = _content$sharers$.sender_email,
    sender_picture_url = _content$sharers$.sender_picture_url;
  var count = content.sharers.length - 1;
  var name = getFullUserName({
    first_name: sender_first_name,
    last_name: sender_last_name
  }) || sender_email;
  var label = count > 0 ? i18n.t('shared_by_multiple', {
    name: name,
    count: count
  }) : i18n.t('shared_by', {
    name: name
  });
  if (name === 'anonymous') {
    label = i18n.t('shared_with_you');
  }
  return {
    count: count,
    label: label,
    name: name,
    pictureUrl: sender_picture_url
  };
}
export default getSharedByDetails;